<template>
  <div class="about-container">
    <div class="about-container-left">
      <pageNav :active="1" />
    </div>
    <div class="about-container-right">
      <div class="about-container-right-describe" v-html="text"></div>
    </div>
  </div>
</template>
<script>
import { i18n } from '@/i18n'
export default {
  name: 'AboutDescribe',
  meta: {
    title: i18n.$t('关于')
  },
  data () {
    return {
      text: this.$i18n.$t(`<div class="about-container-right-describe-title">使用说明</div>
        <div class="about-container-right-describe-p">历代高僧传知识图谱项目旨在搭建历代高僧传知识图谱研究平台，为研究人员与读者提供研究历代高僧传的便利。本项目文本来自于八部传记：《高僧传》、《续高僧传》、《宋高僧传》、《大明高僧传》、《比丘尼传》、《出三藏记集》、《名僧传抄》、《补续高僧传》，文本规模133.7万字，其中包括传记人物2772人、传记涉及的扩展人物6500人。</div>
        <div class="about-container-right-describe-table">
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-th">传记名称</div>
            <div class="about-container-right-describe-table-tr-th">正传人物(人)</div>
            <div class="about-container-right-describe-table-tr-th">附见人物(人)</div>
            <div class="about-container-right-describe-table-tr-th">总人物(人)</div>
            <div class="about-container-right-describe-table-tr-th">字数(万)</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">高僧传(梁)</div>
            <div class="about-container-right-describe-table-tr-td">257</div>
            <div class="about-container-right-describe-table-tr-td">235</div>
            <div class="about-container-right-describe-table-tr-td">492</div>
            <div class="about-container-right-describe-table-tr-td">16.4</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">续高僧传(唐)</div>
            <div class="about-container-right-describe-table-tr-td">484</div>
            <div class="about-container-right-describe-table-tr-td">207</div>
            <div class="about-container-right-describe-table-tr-td">691</div>
            <div class="about-container-right-describe-table-tr-td">46.5</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">宋高僧传</div>
            <div class="about-container-right-describe-table-tr-td">531</div>
            <div class="about-container-right-describe-table-tr-td">122</div>
            <div class="about-container-right-describe-table-tr-td">653</div>
            <div class="about-container-right-describe-table-tr-td">30.6</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">大明高僧传</div>
            <div class="about-container-right-describe-table-tr-td">112</div>
            <div class="about-container-right-describe-table-tr-td">69</div>
            <div class="about-container-right-describe-table-tr-td">181</div>
            <div class="about-container-right-describe-table-tr-td">5.4</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">比丘尼传</div>
            <div class="about-container-right-describe-table-tr-td">65</div>
            <div class="about-container-right-describe-table-tr-td">0</div>
            <div class="about-container-right-describe-table-tr-td">65</div>
            <div class="about-container-right-describe-table-tr-td">2.1</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">出三藏记集</div>
            <div class="about-container-right-describe-table-tr-td">32</div>
            <div class="about-container-right-describe-table-tr-td">0</div>
            <div class="about-container-right-describe-table-tr-td">32</div>
            <div class="about-container-right-describe-table-tr-td">3.3</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">名僧传抄</div>
            <div class="about-container-right-describe-table-tr-td">36</div>
            <div class="about-container-right-describe-table-tr-td">0</div>
            <div class="about-container-right-describe-table-tr-td">36</div>
            <div class="about-container-right-describe-table-tr-td">1.3</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td">补续高僧传</div>
            <div class="about-container-right-describe-table-tr-td">549</div>
            <div class="about-container-right-describe-table-tr-td">73</div>
            <div class="about-container-right-describe-table-tr-td">622</div>
            <div class="about-container-right-describe-table-tr-td">28.1</div>
          </div>
          <div class="about-container-right-describe-table-tr is_total">
            <div class="about-container-right-describe-table-tr-td">共计</div>
            <div class="about-container-right-describe-table-tr-td">2066</div>
            <div class="about-container-right-describe-table-tr-td">706</div>
            <div class="about-container-right-describe-table-tr-td">2772</div>
            <div class="about-container-right-describe-table-tr-td">133.7</div>
          </div>
        </div>
        <div class="about-container-right-describe-p">本项目的主要功能包括人物社会关系图谱、人物师承关系图谱、人物足迹图谱、人物-地点关系图谱、人物-记载关系图谱、时间图谱等。所构建的知识图谱融合人物、时间、地点、记载出处等多实体及相互关系，采用社会网络技术、地理信息技术等，实现在一个平台集成所有实体关系的呈现和关系挖掘。此外，人物检索结果包括了人物基础数据及关系图谱、原文、白话文等全方位信息，同时高僧传记的图谱检索与如是佛典平台的阅读功能实现了无缝连接。</div>
        <div class="about-container-right-describe-table">
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-th" style="width: 200px;flex: unset;">功能名称</div>
            <div class="about-container-right-describe-table-tr-th">功能说明</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">首页</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">人物的基础检索、热点人物图谱展示、热门地点展示、传记阅读(如是佛典)等功能</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">高级检索</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据名称、分类、传记、宗派、朝代进行人物信息检索，检索结果可提供Excel!格式下载，并可链接到对应人物的社会关系、师承关人物足迹、记载关系图谱。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">社会关系图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据名称、分类、传记、宗派、朝代呈现人物社会关系无向加权网络，关系定义为同一段文本的共现关系，点击人物节点呈现该人物详细信息，点击连边呈现该关系的记载出处，双击节点可展开下一级社会关系，数据提供Excel格式下载。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">师承关系图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据名称、分类、传记、宗派、朝代呈现人物师承关系的有向网络，关系箭头指向为老师一学生。点击人物节点呈现该人物详细信息，点击连边呈现该关系的记载出处，双击节点可展开下一级师承关系，数据提供Excel格式下载。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">人物足迹图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据人物名称在地图上呈现该人物的人物-地点关系图谱，连边包括途经地、籍贯地、驻锡地三种类型。点击人物节点呈现该人物详细信息，点击地点节点呈现该地点的介绍数据，点击连边呈现该关系的记载出处，数据提供Excel格式下载。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">地点查询图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据地点名称生成该地点的地点-人物关系图谱，操作同人物足迹图谱。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">传记记载图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据人物名称生成该人物的记载关系图谱，提供该人物在所有传记中的记载信息。点击人物节点呈现该人物的详细信息，点击传记节点呈现该篇传记记载的原文，数据提供Excel格式下载。</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">关系发现</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">输入两个人物名称，发现两个人物之间的关系，包括社会关系、师承关系、地点关系等</div>
          </div>
          <div class="about-container-right-describe-table-tr">
            <div class="about-container-right-describe-table-tr-td" style="width: 200px;flex: unset;">时间图谱</div>
            <div class="about-container-right-describe-table-tr-td" style="text-align: left;">根据分类、宗派、传记、朝代对所有传记人物进行统计，生成各朝代各类别的高僧人物名称及数量，数据提供Excel格式下载。</div>
          </div>
        </div>
        <div class="about-container-right-describe-h2">本项目的构建特色如下：</div>
        <div class="about-container-right-describe-p">（1）图谱一键溯源能力：基于单人细颗粒度文本单元，实现从文本数据→结构化数据→图谱知识库的逐级构建；从图谱知识库→结构化数据→文本数据的逐级溯源。在图谱上直接提供原始文本的“一键”溯源能力，同时将人物数据库融合到原始文本的溯源过程中，使图谱的质量得到保证，同时为学术研究的溯源提供便利。</div>
        <div class="about-container-right-describe-p">（2）图谱数据整合能力：实现文本数据→结构化数据→图谱知识库的多级数据整合应用，用户可以方便地从图谱查询获取到某历史人物的多级数据，而不用到不同的数据来源中进行搜索和汇总。图谱数据的整合能力可以更好地支持对历史人物的深度研究。</div>
        <div class="about-container-right-describe-p">（3）图谱跨时空与扩充能力：针对历代高僧传记的文本特点，围绕人物的时间、地点、记载来源三要素进行实体-关系的抽取和设计，为全方位地了解历史人物提供了跨时间、跨地理、跨来源的丰富可视化体验。</div>
        <div class="about-container-right-describe-p">（4）弹性灵活的视觉呈现：在当前主流布局的基础上，提供了弹性灵活的定制操作，用户可以自己通过拖拽、缩放、平移等操作设计图形的整体及局部细节，以满足使用需求。</div>
        <div class="about-container-right-describe-p">（5）图谱数据分析与导出能力：本项目提供了数据分析区，给出详细的图谱数据与统计信息。同时所有的数据均可以导出进行进一步利用，用户可以根据自己的需要，在导出数据的基础上进行统计分析、网络计算等深入研究。</div>
        <div class="about-container-right-describe-p">（6）与如是佛典的高度集成：作为如是佛典平台的专题项目，知识图谱系统与如是佛典平台实现了高度集成，包括统一登录、统一问题反馈、统一用户中心，以为用户提供便捷。同时，知识图谱系统无缝集成了佛典平台的阅读功能，支持历代高僧传的阅读。</div>
        <div class="about-container-right-describe-p">本项目提供的所有数据受著作权法保护，数据使用限定于个人或团体的非盈利用途。若用于盈利性目的，必须事先取得本单位和原始数据版权者的同意。在对本项目数据进行传播、引用或再加工发行时，以不改变实质内容为原则，并需在使用时标注本项目数据来源，以利于使用者查询到相关原始信息。</div>
        <div class="about-container-right-describe-p">本项目为非盈利公益项目，对于使用本项目数据产生的任何后果，本单位一概不负任何责任。</div>
        <div class="about-container-right-describe-p">欢迎对数据的错漏之处提出完善建议，欢迎使用者进行学术研究合作，本项目联系方式：<a href="mailto:tripitakas@rushi-ai.net">tripitakas@rushi-ai.net</a>。</div>
        <div class="about-container-right-describe-p">要了解更多的系统功能及操作方式，请下载用户使用手册。</div>
        <div class="about-container-right-describe-p"><a href="/历代高僧传知识图谱用户手册.pdf">历代高僧传知识图谱用户手册.pdf</a></div>`)
    }
  }
}
</script>
